/* eslint-disable import/no-cycle */
import React from 'react';
import loadable from '@loadable/component';

/* istanbul ignore next */
export const SerialCodeInputModal = loadable(
    () =>
        import(
            /* webpackChunkName: "CouponsModuleLazy" */ 'yoda-checkout-components/lib/components/Coupons/SerialCodeInputModal/SerialCodeInputModal'
        ),
    {}
);

/* istanbul ignore next */
export const CouponsPanel = loadable(
    () =>
        import(
            /* webpackChunkName: "CouponsModuleLazy" */ 'yoda-checkout-components/lib/components/Coupons/CouponsPanel'
        ),
    {}
);

/* istanbul ignore next */
export const ShowRewardsPanel = loadable(
    () =>
        import(
            /* webpackChunkName: "CouponsModuleLazy" */ 'yoda-checkout-components/lib/components/ShowRewardsPanel/ShowRewardsPanel'
        ),
    {}
);

/* istanbul ignore next */
export const SessionTimeoutModal = loadable(
    () =>
        import(
            /* webpackChunkName: "SessionTimeoutModalLazy" */ 'yoda-checkout-components/lib/components/SessionTimeoutModal/SessionTimeoutModal'
        ),
    {}
);

/* istanbul ignore next */
export const OOSModal = loadable(
    () =>
        import(
            /* webpackChunkName: "OOSModalLazy" */ 'yoda-checkout-components/lib/components/OOSModal/OOSModal'
        ),
    {}
);

/* istanbul ignore next */
export const GenericOopsMessage = loadable(
    () =>
        import(
            /* webpackChunkName: "GenericOopsMessageLazy" */ 'yoda-checkout-components/lib/components/GenericOopsMessage/GenericOopsMessage'
        ),
    {}
);

/* istanbul ignore next */
export const ReviewShippingGroupList = loadable(
    () =>
        import(
            /* webpackChunkName: "ReviewShippingGroupListLazy" */ '../components/ReviewShippingGroupList/ReviewShippingGroupList'
        ),
    {}
);

/* istanbul ignore next */
export const NewGiftCardForm = loadable(
    () =>
        import(
            /* webpackChunkName: "NewGiftCardFormLazy" */ '../containers/Pages/NewPaymentPage/NewGiftCardPayment/NewGiftCardForm/NewGiftCardForm'
        ),
    {}
);

/* istanbul ignore next */
export const NewCheckoutPage = loadable(
    () =>
        // eslint-disable-next-line import/no-cycle
        import(
            /* webpackChunkName: "NewCheckoutPage" */ '../containers/Pages/NewCheckoutPage/NewCheckoutPage'
        ),
    { fallback: <div /> }
);

/* istanbul ignore next */
export const NewSameDayPickupPage = loadable(
    () =>
        import(
            /* webpackChunkName: "NewSameDayPickupPage" */ '../containers/Pages/NewSameDayPickupPage/NewSameDayPickupPage'
        ),
    { fallback: <div /> }
);

/* istanbul ignore next */
export const NewShippingPage = loadable(
    () =>
        import(
            /* webpackChunkName: "NewShippingPage" */ '../containers/Pages/NewShippingPage/NewShippingPage'
        ),
    { fallback: <div /> }
);

/* istanbul ignore next */
export const NewPaymentPage = loadable(
    () =>
        import(
            /* webpackChunkName: "NewPaymentPage" */ '../containers/Pages/NewPaymentPage/NewPaymentPage'
        ),
    { fallback: <div /> }
);
